"use strict";

var km = require('keymirror');

var KeyType = {
  Types: km({
    NORMAL: null,
    NUMERIC: null,
    NUMERIC_EXTENDED: null,
    BACKSPACE: null,
    NORMAL_3: null,
    NORMAL_5: null,
    NORMAL_2_5: null,
    RIGHT_PANEL: null
  }),

  /**
   *
   * @param type {string}
   */
  className: function (type) {
    switch (type) {
      case this.Types.NUMERIC:
        return "numberpad-keys";
      case this.Types.NUMERIC_EXTENDED:
        return "numberpad-keys-extended";
      case this.Types.BACKSPACE:
        return "numberpad-keys-extended-special keyboard-backspace-key";
      case this.Types.NORMAL:
        return 'keyboard-keys';
      case this.Types.NORMAL_3:
        return "keyboard-keys keyboard-keys-extended-3x";
      case this.Types.NORMAL_5:
        return "keyboard-keys keyboard-keys-extended-5x";
      case this.Types.NORMAL_2_5:
        return "keyboard-keys keyboard-keys-extended-2point5x";
      case this.Types.RIGHT_PANEL:
        return "keybard-right-panel-buttons";
    }
  }
};

module.exports = KeyType;



// WEBPACK FOOTER //
// ./src/components/OnScreenKeyboard/keyboardKeyType.js